import { createAction } from "@redux/actions/actionCreators";

const [useClearQueryFilter, clearQueryFilter] = createAction("search/clearQueryFilter", () => {
  // Ensure that click events aren't passed in
  return { payload: null };
});

export default useClearQueryFilter;
export { clearQueryFilter };
